import { Box, Typography, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AuditStatus, AuditStatusLabel } from "../../../../../utils/enums";

const AuditHeader = ({ processedAudit, noBottomMargin = false }) => {
  const theme = useTheme();
  const statusKey = processedAudit?.audit_status || AuditStatus.ACTIVE;
  const statusLabel = AuditStatusLabel[statusKey] || "Active";

  return (
    <Box sx={{ pb: 0 }}>
      <Typography variant="h5">
        {processedAudit.audit_name || "Unnamed Audit"}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mb: noBottomMargin ? 0 : 3 }}>
        <Typography variant="body2">
          {processedAudit.framework_name}
        </Typography>
        {processedAudit.audit_type && (
          <Chip
            label={processedAudit.audit_type.charAt(0).toUpperCase() + processedAudit.audit_type.slice(1)}
            size="small"
            sx={{
              bgcolor: '#E5F7FF',
              color: '#0277BD',
              fontWeight: 600,
              fontSize: '0.75rem',
              height: 24,
            }}
          />
        )}
        <Chip
          label={statusLabel}
          size="small"
          sx={{
            backgroundColor:
              statusKey === AuditStatus.ACTIVE
                ? theme.customColors.status.success.bg
                : theme.customColors.status.error.bg,
            color:
              statusKey === AuditStatus.ACTIVE
                ? theme.customColors.status.success.text
                : theme.customColors.status.error.text,
            fontWeight: 600,
            fontSize: '0.75rem',
            height: 24,
          }}
        />
      </Box>
    </Box>
  );
};

export default AuditHeader;
